module.exports = __webpack_public_path__ + "static/media/IMG_2896.ae216beb.JPG";